import bind from 'bind-decorator';

import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./FontSizeInput.less');
const cx = classnames.bind(styles);

export interface IFontSizeInputProps
{
    value:number;

    selected:number;
    data:Array<number>;

    isSelected?:boolean
    onChange:(fontSize:number, closePopover?:boolean) => void;
    onRef:(element:HTMLElement) => void
}

export interface IFontSizeInputState
{
}

export class FontSizeInput extends React.Component<IFontSizeInputProps, IFontSizeInputState>
{
    private _inputElement:HTMLInputElement = null;

    public render()
    {
        const {value, isSelected} = this.props;

        return (
            <input
                className={cx('input', {isSelected})}
                type={'text'}
                disabled={!isSelected}
                value={value !== 0 ? value : ''}
                onChange={this._onChange}
                ref={this._onElementRef}
                onKeyDown={this._onKeyDown}
            />
        );
    }

    @bind
    private _onElementRef(element:HTMLInputElement):void
    {
        if( !element )
            return;

        this._inputElement = element;

        const {onRef} = this.props;
        onRef && onRef(element);
    }

    @bind
    private _onChange(e:React.FormEvent<HTMLInputElement>):void
    {
        const {onChange} = this.props;

        var value = e.currentTarget.value;

        onChange && onChange(parseInt(value) || 0, false);
    }

    @bind
    private _onKeyDown(e:React.KeyboardEvent<HTMLInputElement>):void
    {
        const {onChange} = this.props;

        if( !onChange ) return;

        if( e.keyCode === 27 ) // enter
        {
            return;
        }

        if( e.keyCode === 13 ) // enter
        {
            e.stopPropagation();
            e.preventDefault();
            onChange(parseInt(e.currentTarget.value));
            return;
        }

        if( e.keyCode !== 38 && e.keyCode !== 40 ) return;

        let delta = 0;

        if( e.keyCode === 38 ) delta = -1; // up
        if( e.keyCode === 40 ) delta = +1; // down

        if( !delta )
        {
            onChange(parseInt(e.currentTarget.value) || 0, false);
            return;
        }

        e.stopPropagation();
        e.preventDefault();

        const {selected, data} = this.props;

        let selectedIndex = data.indexOf(selected);

        // if( selectedIndex === -1 ) return; // ???

        selectedIndex += delta;

        if( selectedIndex > data.length - 1 ) selectedIndex = 0;
        if( selectedIndex < 0 ) selectedIndex = data.length - 1;

        const fontSizeFromDataArray = data[selectedIndex];

        onChange(fontSizeFromDataArray, false);

        // setTimeout(() =>
        // {
        //     this._inputElement.select();
        // }, 0);
    }
}
